const TransactionAPI = {
  transactions: {
    list: '/transactions',
    deposit: '/transactions/deposit',
    withdrawal: '/transactions/withdrawal_request/:id',
    withdrawal_list: '/transactions/withdrawal_request',
    deduct: '/transactions/deduct',
  },

}
export default TransactionAPI
